import { LivePreview } from '../components/LivePreview';
import { DEPT_OPTIONS, getActionDisplay } from '../featureFormConstants';
import { SOVEREIGN } from '../../../epc/utils/epcProjectVisual';
import type { FeatureFormApi } from '../useFeatureForm';

export function ReviewStep({ form }: { form: FeatureFormApi }) {
  const {
    name, icon, route, isGroupMenu, department, moduleInput, scopeActions, parentName,
    actionCatalog, key, permissionKey, order, isActive, primaryAction, description,
  } = form;

  return (
    <div className="space-y-4">
      <p
        className="text-sm"
        style={{ color: SOVEREIGN.kpiCaption }}
      >
        Review the feature before saving. This is exactly how it will appear and what roles can grant.
      </p>

      <LivePreview name={name} icon={icon} route={isGroupMenu ? '#' : route} dept={department}
        module={moduleInput} scopeActions={scopeActions} parentName={parentName} actionCatalog={actionCatalog} />

      <div
        className="rounded-xl p-3 space-y-2 text-xs"
        style={{
          background: SOVEREIGN.cardBg,
          border: `1px solid ${SOVEREIGN.cardBorder}`,
        }}
      >
        <p
          className="font-bold mb-2"
          style={{ color: SOVEREIGN.title }}
        >
          Summary
        </p>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Key:</span>
          <code
            className="font-mono text-right"
            style={{ color: SOVEREIGN.ink }}
          >
            {key || '—'}
          </code>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Route:</span>
          <code
            className="font-mono text-right truncate max-w-[180px]"
            style={{ color: SOVEREIGN.ink }}
          >
            {isGroupMenu ? '#' : route || '—'}
          </code>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>PermKey:</span>
          <code
            className="font-mono text-right truncate max-w-[180px]"
            style={{ color: SOVEREIGN.bottle }}
          >
            {permissionKey}
          </code>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Business Unit:</span>
          <span
            className="font-semibold"
            style={{ color: SOVEREIGN.ink }}
          >
            {DEPT_OPTIONS.find(d => d.value === department)?.icon} {department}
          </span>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Parent:</span>
          <span style={{ color: SOVEREIGN.ink }}>{parentName || 'None (top level)'}</span>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Order:</span>
          <span style={{ color: SOVEREIGN.ink }}>{order}</span>
        </div>
        <div className="flex justify-between">
          <span style={{ color: SOVEREIGN.kpiCaption }}>Status:</span>
          <span
            className="font-semibold"
            style={{ color: isActive ? SOVEREIGN.brand : '#dc2626' }}
          >
            {isActive ? '✓ Active' : '✗ Inactive'}
          </span>
        </div>
        {description.trim() && (
          <div
            className="pt-1"
            style={{ borderTop: `1px solid ${SOVEREIGN.innerRule}` }}
          >
            <span style={{ color: SOVEREIGN.kpiCaption }}>Description:</span>
            <p
              className="mt-0.5"
              style={{ color: SOVEREIGN.ink }}
            >
              {description.trim()}
            </p>
          </div>
        )}
      </div>

      <div
        className="rounded-xl p-3"
        style={{
          background: SOVEREIGN.cardBg,
          border: `1px solid ${SOVEREIGN.cardBorder}`,
        }}
      >
        <p
          className="text-xs font-bold mb-2"
          style={{ color: SOVEREIGN.title }}
        >
          Role Permission Matrix
        </p>
        <p
          className="text-xs mb-2"
          style={{ color: SOVEREIGN.kpiCaption }}
        >
          In "Create Role", this module will appear with:
        </p>
        <div className="space-y-1">
          {scopeActions.length > 0 ? scopeActions.map(a => {
            const display = getActionDisplay(a);
            const cat = actionCatalog.find(x => x.key === a);
            return (
              <div key={a} className={`flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs border ${display.color}`}>
                <span>{display.emoji}</span>
                <span className="font-medium">{cat?.name ?? a}</span>
                {a === primaryAction && (
                  <span
                    className="ml-auto text-xs opacity-60"
                    style={{ color: SOVEREIGN.champagne }}
                  >
                    ★ menu access
                  </span>
                )}
              </div>
            );
          }) : (
            <p
              className="text-xs"
              style={{ color: SOVEREIGN.kpiCaption }}
            >
              No actions selected
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
